var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0001 0C11.7567 0 11.5152 0.00811267 11.2754 0.0224064C17.5653 0.397183 22.2428 5.61595 22.2428 12C22.2428 18.384 17.5653 23.6028 11.2754 23.9776C11.5152 23.9919 11.7567 24 12.0001 24C18.6275 24 24.0001 18.6274 24.0001 12C24.0001 5.37257 18.6275 0 12.0001 0Z",
    fill: "#F8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0005 22.2432C17.6574 22.2432 22.2432 17.6574 22.2432 12.0005C22.2432 6.34362 17.6574 1.75781 12.0005 1.75781C6.34362 1.75781 1.75781 6.34362 1.75781 12.0005C1.75781 17.6574 6.34362 22.2432 12.0005 22.2432Z",
    fill: "#23AB41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 1.75781C11.7564 1.75781 11.5148 1.76694 11.2754 1.78365C16.5941 2.15548 20.7934 6.58732 20.7934 12.0005C20.7934 17.4137 16.5941 21.8455 11.2754 22.2174C11.5148 22.2341 11.7564 22.2432 12 22.2432C17.6569 22.2432 22.2427 17.6574 22.2427 12.0005C22.2427 6.34365 17.6569 1.75781 12 1.75781Z",
    fill: "#23AB41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.1951 9.9401L11.6571 16.4785C10.9637 17.1715 9.84045 17.1715 9.1475 16.4785L5.80391 13.1349C5.41953 12.751 5.41953 12.1281 5.80391 11.7442L6.7784 10.7697V10.7692L7.1087 10.4389C7.49261 10.055 8.11555 10.055 8.49945 10.4389L10.1727 12.1122C10.3523 12.2923 10.6445 12.2923 10.8241 12.1122L15.5956 7.34066C15.9795 6.95676 16.6025 6.95676 16.9864 7.34066L18.1951 8.54935C18.5794 8.93374 18.5794 9.5562 18.1951 9.9401Z",
    fill: "#F8EEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.825 12.1116L10.2711 12.6654C10.0529 12.8842 9.69889 12.8856 9.47821 12.6688L7.78469 11.0062C7.51282 10.7339 7.12119 10.6556 6.7793 10.7691V10.7686L7.1096 10.4383C7.4935 10.0544 8.11644 10.0544 8.50034 10.4383L10.1736 12.1116C10.3532 12.2917 10.6454 12.2917 10.825 12.1116Z",
    fill: "#F8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.1963 8.54956L16.9875 7.34077C16.6035 6.95672 15.9808 6.95672 15.5968 7.34077L15.2843 7.6533C15.5656 7.62708 15.856 7.72154 16.0714 7.93696L16.747 8.54961C17.131 8.93366 17.131 9.5563 16.747 9.94035L10.751 16.0151C10.3229 16.4432 9.73045 16.6065 9.17676 16.5056C9.8717 17.1711 10.9742 17.1625 11.658 16.4787L18.1964 9.94035C18.5804 9.5563 18.5804 8.93361 18.1963 8.54956Z",
    fill: "#F8EEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPass);
export default __webpack_public_path__ + "static/media/icon_pass.047927e4639ff5ea0755293af4741f05.svg";
export { ForwardRef as ReactComponent };